import { store } from '../store/store';

const deleteItem = async (itemId) => {
    const state = store.getState();
    const token = state.user.currentUser.token;
    const API_BASE = state.user.apiBase;

    try {
        const response = await fetch(`${API_BASE}/items/${itemId}`, {
            method: 'DELETE',
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            }
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        return data;
    } catch (error) {
        console.error("Error deleting item:", error);
        throw error;
    }
};

export default deleteItem;

//api.DELETE("/items/:id",